/**
 * An AMD wrapper around doT for loaders (like DOJO) that don't
 * support shims
 */
define(['/bower_components/doT/doT.js'], function(doT){
	// DoT actually loads correctly via the AMD loader, but needs to be loaded
	// in legacy fashion for DOJO
	return doT;
});